import { HarvestEvents, StoreCrops } from '../../types';
import { adaptUapiHarvestResponse } from './uapiHarvestAdapter';

import { LegacyCropsMap } from '../types/LegacyCropsMap';
import { getGraphqlClient } from '../uapiConnection';
import { getSdk } from '../../graphql/sdk';

export async function requestUapiHarvestEvents(fieldUuid: string, cropsMap: StoreCrops): Promise<HarvestEvents> {
  const sdk = getSdk(getGraphqlClient());
  const response = await sdk.getHarvestEventAggregatesArd({ fieldUuid });
  
  const crops: LegacyCropsMap = Object.entries(cropsMap).reduce((accum, [legacySeasonCode, crop]) => ({
      ...accum,
      [crop['dfp-uuid']]: legacySeasonCode,
    }), {});

  return adaptUapiHarvestResponse(response.data, crops);
}
